import { AppsRoutes, getRoute } from '@wellesley/router'
import { User, UserFull } from '@wellesley/openapi'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

export enum ProfileTabs {
  posts = 'posts',
  replies = 'replies',
  reposts = 'reposts',
  events = 'events',
  media = 'media',
}

export enum ActivityTabs {
  likes = 'likes',
  quotes = 'quotes',
  reposts = 'reposts',
}

export enum NotificationTabs {
  all = 'all',
  follow = 'follow',
  invitations = 'invitations',
}

type GetProfileTabRouter = {
  user: UserFull
  tab: ProfileTabs
}

export const USER_ROUTE = '/@/:username'
export const POST_ROUTE = '/@/:username/posts/:postId'
export const POST_EDITS_ROUTE = '/@/:username/posts/:postId/edits'
export const POST_ACTIVITY_ROUTE = '/@/:username/posts/:postId/activity/:tab?'
export const NOTIFICATIONS_ROUTE = '/notifications/:tab?'
export const PROFILE_TABS_ROUTE = '/@/:username/profile/:tab?'

export const ROOT_ROUTE = '/'
export const BOOKMARKS_ROUTE = '/bookmarks'
export const PUBLIC_TIMELINE_ROUTE = '/feed/discover'
export const FOLLOWING_TIMELINE_ROUTE = '/feed/following'

export const getUserRoute = (user: User): AppsRoutes =>
  getRoute(USER_ROUTE, { username: getUserNameWithDomain(user) })

export const getProfileTabRoute = ({
  user,
  tab,
}: GetProfileTabRouter): AppsRoutes =>
  getRoute(PROFILE_TABS_ROUTE, {
    username: getUserNameWithDomain(user),
    ...(tab && tab !== ProfileTabs.posts && { tab: ProfileTabs[tab] }),
  })

export const getPostRoute = (user: User, postId: string): AppsRoutes =>
  getRoute(POST_ROUTE, { username: getUserNameWithDomain(user), postId })

export const getCommentRoute = (user: User, postId: string): AppsRoutes =>
  getRoute(POST_ROUTE, { username: getUserNameWithDomain(user), postId })

export const getPostEditsRoute = (user: User, postId: string): AppsRoutes =>
  getRoute(POST_EDITS_ROUTE, { username: getUserNameWithDomain(user), postId })

export const getPostActivityRoute = (
  user: User,
  postId: string,
  tab?: ActivityTabs,
): AppsRoutes =>
  getRoute(POST_ACTIVITY_ROUTE, {
    username: getUserNameWithDomain(user),
    postId,
    ...(tab && tab !== ActivityTabs.likes && { tab }),
  })

export const getNotificationsRoute = (tab?: NotificationTabs): AppsRoutes =>
  getRoute(NOTIFICATIONS_ROUTE, {
    ...(tab && tab !== NotificationTabs.all && { tab }),
  })
